import React from 'react'
import { Box, Tab as MuiTab, Tabs, styled } from '@mui/material'
import { useAppStore } from '../store/useAppStore'
import { useTranslation } from 'react-i18next'

const Tab = styled(MuiTab, {
  shouldForwardProp: (prop) => !['isTabActive', 'isTabFilled'].includes(prop),
})(({ theme, isTabActive = false, isTabFilled = false }) => ({
  padding: theme.spacing(2, 0.25),
  lineHeight: '1rem',
  minWidth: '68px',
  color: theme.palette.grey[700],
  ...(isTabActive && {
    '&.Mui-selected': {
      color: theme.palette.text.primary,
    },
  }),
  ...(isTabFilled && {
    color: theme.palette.primary.main,
  }),
}))

const Navigation = () => {
  const tabValue = useAppStore((state) => state.tabValue)
  const vehicleData = useAppStore((state) => state.vehicleData)
  const setTabValue = useAppStore((state) => state.setTabValue)
  const { t } = useTranslation()

  const handleTabChange = (_, selectedTabValue) => setTabValue(selectedTabValue)

  const navigationTabs = [
    { id: 0, name: t('navigation_tabs.inside') },
    { id: 1, name: t('navigation_tabs.front') },
    { id: 2, name: t('navigation_tabs.left') },
    { id: 3, name: t('navigation_tabs.rear') },
    { id: 4, name: t('navigation_tabs.right') },
  ]

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: '100%',
        backgroundColor: (theme) => theme.palette.background.paper,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.08)',
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
        sx={{
          ...(!vehicleData[tabValue].photo && {
            '& .MuiTabs-indicator': {
              backgroundColor: (theme) => theme.palette.text.primary,
            },
          }),
          '& .MuiTabs-flexContainer': {
            overflow: 'auto',
          },
        }}
      >
        {navigationTabs.map(({ id, name }) => (
          <Tab
            label={name}
            value={id}
            key={id}
            isTabFilled={!!vehicleData[id].photo}
            isTabActive={tabValue === id}
          />
        ))}
      </Tabs>
    </Box>
  )
}

export default Navigation
